export default __webpack_public_path__ + "static/media/drink_bot_spot_FINAL.90800d71.png";